import Checkbox from './checkbox'
export default Checkbox



/** WEBPACK FOOTER **
 ** ./es2015/controls/checkbox/index.js
 **/